module.exports = __webpack_public_path__ + "media/images/regional-image2-c39ca7fe90d0c037e2537272803ce7c5.jpg";